import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import * as html2canvas from "html2canvas";
import {
  NbWindowService,
  NbWindowState,
  NbDialogService,
} from "@nebular/theme";
import { LeadFinanceService } from "../../../@core/api/leadFinance.service";
import { LeadFinance } from "../../../@core/data/leadFinance";
import { Router } from "@angular/router";

@Component({
  selector: "ngx-finance-leads-row",
  templateUrl: "./finance-leads-row.component.html",
  styleUrls: ["./finance-leads-row.component.scss"],
})
export class FinanceLeadsRowComponent implements OnInit {
  @Input() lead: LeadFinance;
  @Output() updateList = new EventEmitter();

  public isResponseVisible: boolean = false;

  constructor(
    private router: Router,
    private dialogService: NbDialogService,
    private leadService: LeadFinanceService
  ) {}

  async ngOnInit() {}

  // Metodo per attivare/disattivare la visibilità della risposta
  toggleResponseVisibility(): void {
    this.isResponseVisible = !this.isResponseVisible;
  }

  async sendLead() {
    this.lead.needToSend = true;
    await this.leadService.sendLeadFinance(this.lead.id);
    this.lead = await this.leadService.getLeadFinance(this.lead.id);
  }
}
